import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { LocalDate } from '../../../core/model/local-date';
import { Command, CommandBase } from '../../../core/model/command';
import { CommandController } from '../../../core/component/base/command-controller.base';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { RentalObjectCategory, SubleaseRequestDecision } from '../../model/const/enums';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { SubleaseRequest } from '../../model/sublease-request';

@Component({
    selector: 'app-sublease-requests',
    templateUrl: './sublease-requests.component.html',
    styleUrls: ['./sublease-requests.component.scss'],
    providers: [CommandDispatcher],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubleaseRequestsComponent extends CommandController implements OnChanges, OnInit {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    handlerResolver: CommandHandlerResolver,
    commandDispatcher: CommandDispatcher
  ) {
    super(commandDispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.create('SubleaseRequest');
    this.menuDefinition = [
      // SubleaseTODO
      //new MenuItemDefinition('SUBLEASE_REQUEST.APPROVE', 'approveSubleaseRequest'),
      //new MenuItemDefinition('SUBLEASE_REQUEST.REJECT', 'rejectSubleaseRequest'),
      new MenuItemDefinition('EDIT_BTN', 'editSubleaseRequest'),
      new MenuItemDefinition('DELETE_BTN', 'deleteSubleaseRequest'),
    ];
  }
  @Input() leaseStartDate: LocalDate;
  @Input() form: AbstractControl;
  @Input() itemsSource: SubleaseRequest[];

  private _isNew: boolean;
  columnDefinition: ColumnDefinition[];
  menuDefinition: MenuItemDefinition[] = [];
  selectedRow: SubleaseRequest;

  private _deleteItem(row: SubleaseRequest) {
    let index = this.itemsSource.indexOf(row);
    if (index > -1) {
      this.itemsSource.splice(index, 1);
      if (this.form.pristine) this.form.markAsDirty();
    }
  }

  private _editItem(row: SubleaseRequest) {
    this.selectedRow = this.itemsSource.find(x => x === row);
  }

  private _approve(row: SubleaseRequest) {
    row.decisionDate = new Date();
    row.decision = SubleaseRequestDecision.Approved;
  }
  private _reject(row: SubleaseRequest) {
    this.selectedRow = this.itemsSource.find(x => x === row);
  }

  canExecute(command: CommandBase): boolean {
    switch (command.id) {
      case 'editSubleaseRequest':
      case 'deleteSubleaseRequest':
      case 'approveSubleaseRequest':
      case 'rejectSubleaseRequest':
        return true;

      default:
        return false;
    }
  }

  execute(command: CommandBase): void {
    switch (command.id) {
      case 'deleteSubleaseRequest':
        this._deleteItem((<Command>command).context);
        break;

      case 'editSubleaseRequest':
        this._editItem((<Command>command).context);
        break;

      case 'approveSubleaseRequest':
        this._approve((<Command>command).context);
        break;

      case 'rejectSubleaseRequest':
        this._reject((<Command>command).context);
        break;
    }
  }

  createItem() {
    let request = new SubleaseRequest();
    request.created = new Date();
    this._approve(request);
    this.itemsSource.push(request);
    this.selectedRow = request;
    this._isNew = true;
  }

  ngOnChanges(changes: SimpleChanges) {}

  ngOnInit() {}

  onCompleted(applyChanges: boolean) {
    if (!applyChanges && this._isNew) {
      this._deleteItem(this.selectedRow);
    }
    if (applyChanges && this.form.pristine) {
      this.form.markAsDirty();
    }
    this.selectedRow = null;
    this._isNew = false;
  }

  onRowClicked(e: { context: SubleaseRequest; event: any }) {
    this._editItem(e.context);
  }
}
